import React from "react";
import styled, { css } from "styled-components";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

const Label = styled.span`
  color: rgb(33, 37, 67);
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
`;

const Required = styled.span`
  color: rgb(220, 38, 38);
  font-size: 12px;
  font-weight: 700;
  margin-left: 4px;
`;

const ErrorMessage = styled.span`
  color: rgb(220, 38, 38);
  font-size: 12px;
  font-family: Montserrat, sans-serif;
  margin-top: 4px;
`;

const StyledPhoneInputWrapper = styled.div`
  .react-tel-input {
    width: 100%;
    display: flex;
    align-items: center;
    border: 1px solid
      ${(props) => (props.error ? "rgb(220, 38, 38)" : "rgb(224, 228, 244)")};
    border-radius: 8px;
    padding: 0 12px;
    background: #ffffff;
    height: 42px;
    transition: border-color 0.2s;

    &:focus-within {
      border-color: rgb(97, 98, 197);
    }

    input {
      flex: 1;
      border: none;
      outline: none;
      font-size: 16px;
      font-family: Montserrat, sans-serif;
      font-weight: 500;
      color: rgb(33, 37, 67);
      background: transparent;
      padding-left: 48px; // enough space for the flag
    }

    .flag-dropdown {
      border: none;
      background: transparent;
    }

    .selected-flag {
      padding-left: 0;
    }
  }
`;

const PhoneInputField = ({
  label,
  value,
  onChange,
  required = false,
  error = false,
  errorMessage = "",
  ...props
}) => {
  return (
    <InputContainer>
      {label && (
        <Label>
          {label}
          {required && <Required>*</Required>}
        </Label>
      )}
      <StyledPhoneInputWrapper error={error}>
        <PhoneInput
          country={"gb"}
          value={value}
          onChange={onChange}
          placeholder="Number"
          inputProps={{
            name: "phone",
            required: required,
          }}
          containerClass="custom-phone-input"
          {...props}
        />
      </StyledPhoneInputWrapper>
      {error && errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </InputContainer>
  );
};

export default PhoneInputField;
